import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const postPlacement = ({ accountId, position, name }) => {
  const placementAttributes = {
    data: {
      type: 'placement',
      attributes: {
        position,
        name,
      },
    },
  }

  return HttpClient().post(
    `/moments/accounts/${accountId}/placements`,
    placementAttributes
  )
}

const createPlacement = (options) => (dispatch) =>
  postPlacement(options)
    .then((response) => {
      const body = response.data
      if (body.data) dispatch(loadJsonApiEntities(body))

      return body.data
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createPlacement
